/**
 * UnsavedBar — the "Unsaved crew changes" bar with its Cancel / Save crew actions.
 *
 * Extracted from CrewSlotEditor so each file declares one component
 * (`react/no-multi-comp`); behaviour is unchanged.
 */
export function UnsavedBar({
  saving,
  onCancel,
  onSave,
}: {
  saving: boolean;
  onCancel: () => void;
  onSave: () => void;
}) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        marginTop: 14,
        paddingTop: 12,
        borderTop: '1px solid var(--nb-border)',
      }}
    >
      <span style={{ flex: 1, fontSize: 12, color: 'var(--nb-muted)' }}>Unsaved crew changes</span>
      <button type="button" className="nb-btn nb-btn-ghost" onClick={onCancel} disabled={saving}>
        Cancel
      </button>
      <button type="button" className="nb-btn nb-btn-primary" onClick={onSave} disabled={saving}>
        {saving ? 'Saving…' : 'Save crew'}
      </button>
    </div>
  );
}
